import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

export default function TermsNoticePopup({ isOpen, onAcknowledge }) {
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);

  // Manage smooth open and close animations
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10); // Small delay to trigger transition
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300); // Wait for animation to finish
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  const handleAcknowledge = () => {
    onAcknowledge();
  };

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
          isAnimating ? "opacity-100" : "opacity-0"
        }`}
      >
        <div
          className={`w-full max-w-md bg-white rounded-lg px-6 py-6 text-center transform transition-all duration-300 ease-in-out ${
            isAnimating ? "scale-100 opacity-100" : "scale-95 opacity-0"
          }`}
        >
          {/* Warning Icon */}
          <div className="mb-4 inline-flex">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-amber-600" />
            </div>
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Reminder
          </h3>

          {/* Message */}
          <div className="text-sm text-gray-700 mb-6 text-left leading-relaxed space-y-3">
            <p>
              Please avoid mentioning the platform or website name in public posts. 
              Promotions or posts about online betting are not allowed on public pages.
            </p>
            <p>
              For concerns, message us privately.
            </p>
            <p className="font-medium">
              Thank you for understanding.
            </p>
          </div>

          {/* Acknowledge Button */}
          <button
            onClick={handleAcknowledge}
            className="w-full px-4 py-3 text-sm font-medium bg-[#0E64D1] text-white rounded-md hover:bg-blue-600 transition-colors"
          >
            I understand
          </button>
        </div>
      </div>
    </>
  );
}
